import { ErrorCategory, ErrorType, StatusCode } from "@app/interfaces/ga4.interface";
import { EventGA4 } from "./eventGa4.model";

export class ErrorGA4 extends EventGA4 {

  error_message: string;
  error_type:  ErrorType;
  error_category:  ErrorCategory;
  error_code:  string;
  error_desc: string;
  error_source:  string;
  error_url:  string;
  statusCode:  StatusCode;
  session_id_kos: string;

  constructor(data){
    super(data)
    if(data.error_category == 'undefinedundefined')
    data.error_category = 'NA'
    this.event = 'am_error'
    this.error_message = data?.error_message || 'NA';
    this.error_type = data?.error_type || 'Error';
    this.error_category = data?.error_category || 'Fix';
    this.error_code = data?.error_code || 'NA';
    this.error_desc = data?.error_desc || 'NA';
    this.error_source = data?.error_source || 'Kiosk';
    this.error_url = data?.error_url || 'NA';
    this.statusCode = data?.statusCode || '400';
    this.session_id_kos = data?.session_id_kos || 'NA';
  }

}
